var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.96227 1.0463C9.68602 0.770052 9.23977 0.770052 8.96352 1.0463L5.49977 4.50297L2.03602 1.03922C1.75977 0.762969 1.31352 0.762969 1.03727 1.03922C0.761016 1.31547 0.761016 1.76172 1.03727 2.03797L4.50102 5.50172L1.03727 8.96547C0.761016 9.24172 0.761016 9.68797 1.03727 9.96422C1.31352 10.2405 1.75977 10.2405 2.03602 9.96422L5.49977 6.50047L8.96352 9.96422C9.23977 10.2405 9.68602 10.2405 9.96227 9.96422C10.2385 9.68797 10.2385 9.24172 9.96227 8.96547L6.49852 5.50172L9.96227 2.03797C10.2314 1.7688 10.2314 1.31547 9.96227 1.0463Z",
    fill: "#E0544B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/Cancel.bae234b929e30f08041ea8317377dd42.svg";
export { ForwardRef as ReactComponent };